import React from "react";
import { resolveImg } from "../../lib/image";

const LOGO_SIZES = {
    sm: { logo: "h-8 w-8", name: 15, sub: 10 },
    md: { logo: "h-12 w-12", name: 17, sub: 10 },
    lg: { logo: "h-16 w-16", name: 18, sub: 11 },
};

export const FONT_FAMILIES = {
    "General Sans": '"General Sans","Satoshi","Inter Tight",sans-serif',
    "Satoshi": '"Satoshi","General Sans","Inter Tight",sans-serif',
    "Inter Tight": '"Inter Tight","Satoshi",system-ui,sans-serif',
    "Fraunces": '"Fraunces","General Sans",serif',
    "Playfair Display": '"Playfair Display","Fraunces",serif',
    "Cormorant Garamond": '"Cormorant Garamond","Playfair Display",serif',
    "Instrument Serif": '"Instrument Serif","Fraunces",serif',
    "Space Grotesk": '"Space Grotesk","General Sans",sans-serif',
    "IBM Plex Serif": '"IBM Plex Serif","Fraunces",serif',
    "DM Serif Display": '"DM Serif Display","Playfair Display",serif',
};

export const Wordmark = ({
    tone = "dark",
    logoUrl = "",
    brandName = "One Tree Hill",
    wordmark = "Prime Wealth",
    logoSize = "md",
    nameColor = "",
    nameFont = "",
    nameSize = 0,
    logoOnly = false,
    textOnly = false,
}) => {
    const sizes = LOGO_SIZES[logoSize] || LOGO_SIZES.md;
    const defaultInk = tone === "dark" ? "#0A0A0A" : "#F5F5F2";
    const sub = tone === "dark" ? "#6B6B67" : "#A1A1AA";
    const ink = (nameColor || "").trim() || defaultInk;
    const fontStack = FONT_FAMILIES[(nameFont || "").trim()] || null;
    const customSize = Number(nameSize) > 0 ? Number(nameSize) : null;

    const LogoEl = logoUrl ? (
        <img
            src={resolveImg(logoUrl)}
            alt={brandName}
            className={`${sizes.logo} object-contain`}
            data-testid="brand-logo-image"
        />
    ) : (
        <div className="brand-dot" aria-hidden />
    );

    const TextEl = (
        <div className="leading-none">
            <div
                className="font-semibold tracking-tight"
                style={{
                    color: ink,
                    fontFamily: fontStack || undefined,
                    fontSize: (customSize || sizes.name) + "px",
                }}
                data-testid="brand-name-text"
            >
                {brandName}
            </div>
            <div
                className="font-body uppercase tracking-[0.22em] mt-1"
                style={{ color: sub, fontSize: sizes.sub + "px" }}
            >
                {wordmark}
            </div>
        </div>
    );

    if (logoOnly) return LogoEl;
    if (textOnly) return TextEl;

    return (
        <div className="flex items-center gap-3 select-none" data-testid="brand-wordmark" aria-label={`${brandName} ${wordmark}`}>
            {LogoEl}
            {TextEl}
        </div>
    );
};
